import { ImportedListing } from '../../_types/imported-listing'
import { extractListingHostname } from '../../_utilities/listing-host'

const savedListingsContainerMotion = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.05, delayChildren: 0.05 },
  },
}

const savedListingsItemMotion = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

/**
 * Filters imported listings down to those saved from a specific host site,
 * matched on the listing's `sourceUrl` hostname. Used to scope the saved
 * listings view to the site the SDK overlay is embedded on.
 *
 * @param {ImportedListing[]} listings - the imported listings to filter
 * @param {string} hostname - the normalised host hostname to match against
 * @returns {ImportedListing[]} the listings saved from that host
 */
const filterImportedListingsByHostname = (
  listings: ImportedListing[],
  hostname: string,
): ImportedListing[] => {
  return listings.filter(
    listing => extractListingHostname(listing.sourceUrl) === hostname,
  )
}

export {
  savedListingsContainerMotion,
  savedListingsItemMotion,
  filterImportedListingsByHostname,
}
